import { useContext, useEffect, useState } from "react";
import { AuthenticationContext } from "../../components/authentication/AuthenticationContext";
import callApi from "../../components/call-api/call-api";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Link } from 'react-router-dom';
import { getPlaylists } from "../../components/apis/music-api";
import { Playlist } from "../../types/Playlist";
import React from "react";
import ButtonBar from "../../components/button-bar/ButtonBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faMusic, faRecordVinyl } from "@fortawesome/free-solid-svg-icons";
import { PlaylistType } from "../../types/PlaylistType";
import { getPlaylistDuration } from "../../components/playlist-helper/playlist-helper";

const Playlists = () => {
  const { getAccessToken } = useContext(AuthenticationContext);
  const [ playlists, setPlaylists ] = useState<Playlist[]>();
    
  useEffect(() => {
    callApi<Playlist[]>(getPlaylists(getAccessToken()), setPlaylists);
  }, [getAccessToken]);

  return (
    <>
      <ButtonBar rightButtons={[
          <Button component={Link} variant="contained" size="small" to={`/Playlists/Create`}>
              <FontAwesomeIcon fontSize="small" color="primary" icon={faAdd} className="icon"/>
              Create A Playlist
          </Button>
      ]} />
      <Stack>
          <Box>
              <Typography variant='h6'>Playlists</Typography>
              <p>{playlists?.length} {(playlists?.length ?? 0) === 1 ? 'playlist' : 'playlists'}</p>
          </Box>
      </Stack>
      {playlists?.map((playlist: Playlist, index: number) =>
        <Box sx={{ p: '6px' }} key={`$playlist-${index}`}>
          <Typography variant="body1">
            <FontAwesomeIcon
              fontSize="small"
              color="primary" 
              icon={playlist.playlistType === PlaylistType.Albums ? faRecordVinyl : faMusic}
              className="icon"/>
            <Link to={`/playlists/${playlist.id}`}>{playlist.name}</Link>
          </Typography>
          <Typography variant="body2" sx={{ color: '#999999' }}>
            {playlist.playlistItems?.length} items
            ({getPlaylistDuration(playlist)})
          </Typography>
        </Box>
      )}
    </>
  )
}

export default Playlists;